import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Login from "./Login";
import { WhatsAppFloat } from "../ui/WhatsAppFloat";

const LoginView = ({ onLogin, isLoading }) => {
  const [searchParams] = useSearchParams();
  // Prefer ?id= (UUID, no PII). Keep ?cpf= as fallback for legacy links.
  const id   = searchParams.get("id")  || "";
  const cpf  = searchParams.get("cpf") || "";
  const tipo = searchParams.get("tipo") || "";

  // Remove PII/IDs from URL immediately so they don't persist in browser history or server logs.
  const clearedRef = useRef(false);
  useEffect(() => {
    if (clearedRef.current) return;
    if (id || cpf) {
      const clean = new URL(window.location.href);
      clean.searchParams.delete("id");
      clean.searchParams.delete("cpf");
      window.history.replaceState(null, "", clean.pathname + (clean.search || ""));
    }
    clearedRef.current = true;
  }, [id, cpf]);

  return (
    <>
      <img
        src="/bg-entrypoint.png"
        alt=""
        style={{
          position: "fixed",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "right bottom",
          opacity: 0.4,
          zIndex: 1,
          pointerEvents: "none",
        }}
      />
      <div style={{ position: "relative", zIndex: 2, width: "100%" }}>
        <Login onLogin={onLogin} isLoading={isLoading} initialId={id} initialCpf={cpf} initialTipo={tipo} />
      </div>
      <WhatsAppFloat />
    </>
  );
};

export default LoginView;
